import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Intent,
  Spinner,
  NonIdealState,
  Text,
  H3,
  H2
} from "@blueprintjs/core";
import * as _ from "lodash";
import { Document, Packer, Paragraph, Media, TextRun } from "docx";
import saveAs from "file-saver";
import ReactFullscreen from "react-full-screen";
import { changeLanguage } from "utlis/translations/i18n";


import "../assets/components/Result.css";

import Session from "../services/Session";
import { base } from "../fire";

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = { session: null, instances: [], loading: true };
    this.sessionId = this.props.match.params.id;
  }

  downloadStats = () => {
    const { session, instances } = this.state;

    let element = document.createElement("a");
    let file = new Blob(
      [JSON.stringify(Session.getStatsResultsForSession(session, instances))],
      { type: "application/json" }
    );
    element.href = URL.createObjectURL(file);
    element.download = `export_session_${session.id}`;
    element.click();
  };
  downloadDoc = async () => {
    let results = Session.getResultsForSession(
      this.state.session,
      this.state.instances
    );
    const feedbacks = Session.getFeedbackAnswersForSession(
      this.state.session,
      this.state.instances
    );
    const packer = new Packer();
    const doc = new Document();
    // const feedbacksParagraph = new Paragraph();

    doc.createParagraph("Résultats\n").heading1();
    switch (this.state.session.metadata.protocol) {
      case "PC": {
        const table = doc.createTable(results.length, 2);
        results = _.orderBy(results, ["points"], ["desc"]);
        const imageBlobs = await Promise.all(
          results.map(async r => {
            const blob = await fetch(r.resource.downloadURL).then(response =>
              response.blob()
            );

            return Promise.resolve(blob);
          })
        );
        results.forEach((r, index) => {
          const image = Media.addImage(doc, imageBlobs[index]);

          table.getCell(index, 0).addContent(image.paragraph);
          table
            .getCell(index, 1)
            .addContent(new Paragraph(`Nr°${index + 1}\n ${r.points} points`));
        });
        break;
      }
      case "MS": {
        const table = doc.createTable(
          results.length,
          this.state.session.data.msCriterias.length + 1
        );
        const imageBlobs = await Promise.all(
          this.state.session.data.sequencesResources.map(async r => {
            const blob = await fetch(r.downloadURL).then(response =>
              response.blob()
            );

            return Promise.resolve(blob);
          })
        );
        this.state.session.data.sequencesResources.forEach((
          r /** criteria */,
          index
        ) => {
          const image = Media.addImage(doc, imageBlobs[index]);

          table.getCell(index, 0).addContent(image.paragraph);
        });
        results = results.map((r /** result */) => {
          let array = [];

          this.state.session.data.msCriterias.forEach((c /** criteria */) =>
            array.push({
              criteria: c.name,
              total: r[c.name].total,
              numberOfVotes: r[c.name].numberOfVotes,
              average: r[c.name].average
            })
          );
          array = _.orderBy(array, ["average"], ["desc"]);
          return array;
        });
        results.forEach((r /** result */, i) => {
          r.forEach((c /** criteria */, j) => {
            const resultParagraph = new Paragraph();

            resultParagraph.addRun(new TextRun(`${c.criteria}`));
            resultParagraph.addRun(new TextRun(`\n\nRang : ${j + 1}`));
            resultParagraph.addRun(new TextRun(`\nMoyenne : ${c.average}`));
            resultParagraph.addRun(
              new TextRun(`\nNombre de votes: ${c.numberOfVotes}`)
            );
            table.getCell(i, j + 1).addContent(resultParagraph);
          });
        });
        break;
      }
      case "MC": {
        const table = doc.createTable(results.length, 2);

        results = results.map((r /** result */) => {
          let array = [];

          this.state.session.data.mcCriterias.forEach((c /** criteria */) => {
            if (!r[c.name]) return;
            array.push({
              criteria: c.name,
              total: r[c.name].total,
              numberOfVotes: r[c.name].numberOfVotes,
              average: r[c.name].average
            });
          });
          return array;
        });
        this.state.session.data.sequences.forEach((
          r /** criteria */,
          index
        ) => {
          table
            .getCell(index, 0)
            .addContent(new Paragraph(`Sequence ${index}`));
        });
        results.forEach((r /** result */, i) => {
          r.forEach((c /** criteria */, j) => {
            const resultParagraph = new Paragraph();

            resultParagraph.addRun(new TextRun(`${c.criteria}`));
            resultParagraph.addRun(new TextRun(`\nMoyenne : ${c.average}`));
            resultParagraph.addRun(
              new TextRun(`\nNombre de votes: ${c.numberOfVotes}`)
            );
            if (j < r.length - 1) resultParagraph.addRun(new TextRun(`\n`));
            table.getCell(i, 1).addContent(resultParagraph);
          });
        });
        break
      }
      default:
        return null
    }
    doc.createParagraph("\n\nFeedbacks\n").heading1();
    feedbacks.forEach((f /** feedback */) => {
      doc.createParagraph(f.feedback.question).heading2();
      f.answers.forEach((a /** answer */) => {
        doc.createParagraph(
          `- Participant ${a.participantId.slice(0, 6).toUpperCase()}\n${a.answer
          }`
        );
      });
    });
    packer.toBlob(doc).then(blob => {
      saveAs(blob, "example.docx");
    });
  };

  render() {
    const { instances = [], loading, session = {} } = this.state;
    let results = null;

    if (loading) return <Spinner className="margin-top-medium" />;
    if (session == null)
      return (
        <NonIdealState
          icon="thumbs-down"
          title="Session introuvable"
          description="Nous n'avons pas pu trouver la session."
          action={
            <Link to="/">
              <Button
                text="Liste des sessions"
                intent={Intent.PRIMARY}
                rightIcon="properties"
              />
            </Link>
          }
        />
      );
    if (instances.length === 0)
      return (
        <NonIdealState
          icon="circle"
          title="Résultat indisponible"
          description="Cette session semble ne pas diposer de résultats !"
          className="margin-top-medium"
        />
      );
    results = Session.getResultsForSession(session, instances);
    switch (session.metadata.protocol) {
      case "PC" /** Use constants */:
        return (
          <div>
            <div className="text-center" style={{ marginTop: "15px" }}>
              <h2>{session.metadata.name}</h2>
              {session.metadata.context} <br />
              Cette session a été jouée {instances.length} fois
            </div>
            <div className="text-right">
              <Button
                text="Export les résultats"
                style={{ marginTop: "15px" }}
                onClick={this.downloadStats}
              />
              <Button
                text="Générer document Word"
                style={{ marginTop: "15px", marginLeft: "5px" }}
                onClick={this.downloadDoc}
              />
            </div>
            <PairComparaisonResults results={results} instances={instances} />
          </div>
        );
      case "MS" /** Use constants */:
        return (
          <div>
            <div className="text-right" style={{ marginTop: "15px" }}>
              Cette session a été jouée {instances.length} fois
            </div>
            <div className="text-right">
              <Button
                text="Export les résultats"
                style={{ marginTop: "15px" }}
                onClick={this.downloadStats}
              />
              <Button
                text="Générer document Word"
                style={{ marginTop: "15px", marginLeft: "5px" }}
                onClick={this.downloadDoc}
              />
            </div>
            <MultipleScaleResults session={session} results={results} />
          </div>
        );
      case "MC" /** Use constants */:
        return (
          <div>
            <div className="text-center" style={{ marginTop: "15px" }}>
              <h2>{session.metadata.name}</h2>
              {session.metadata.context} <br />
              Cette session a été jouée {instances.length} fois
            </div>
            <div className="text-right">
              <Button
                text="Export les résultats"
                style={{ marginTop: "15px" }}
                onClick={this.downloadStats}
              />
              <Button
                text="Générer document Word"
                style={{ marginTop: "15px", marginLeft: "5px" }}
                onClick={this.downloadDoc}
              />
            </div>
            <MultipleChannelResults session={session} results={results} />
          </div>
        );
      case "CM" /** Use constants */:
        return (
          <div>
            <div className="text-center" style={{ marginTop: "15px" }}>
              <H2>{session.metadata.name}</H2><br />
              <H3>{session.metadata.context} </H3>
              <br />
              Cette session a été jouée {results[0] ? results[0].votersAmount : 0} fois
                <ManualChoiceResults results={results} instances={instances} />
            </div>
          </div>
        );
      default:
        return <div>Unknown protocol</div>;
    }
  }

  componentDidMount() {
    /**
     * TODO: Check if we don't have the same issue that we had on user
     * (because we set sessionId in constructor and we need a refresh to update the value)
     */
    Session.getSessionById(this.sessionId).then(session => {
      if (!session) return this.setState({ loading: false, session: null });
      this.setState({ session });
      // Change la langue de l'interface selon la langue de la session
      if (session.metadata.language) {
        changeLanguage(session.metadata.language);
      }
      this.syncSessionInstances = Session.syncSessionInstances(session.id, {
        context: this,
        state: "instances",
        asArray: true,
        then: () => this.setState({ loading: false })
      });
    });
    document.body.style.background = "#232526";
    document.body.style.background =
      "-webkit-linear-gradient(to right, #232526, #414345)";
    document.body.style.background =
      "linear-gradient(to right, #232526, #414345)";
  }

  componentWillUnmount() {
    document.body.style.background = null;
    if (this.syncSessionInstances)
      base.removeBinding(this.syncSessionInstances);
  }
}

class MultipleScaleResults extends React.Component {
  render() {
    const { results, session } = this.props;
    const { data } = session;
    const { msCriterias = [] } = data;

    return (
      <div>
        {msCriterias.map((criteria, index) => (
          <MultipleScaleCriteriaResume
            key={index}
            criteria={criteria}
            session={session}
            results={results}
          />
        ))}
      </div>
    );
  }
}

class MultipleScaleCriteriaResume extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showAllResults: false };
  }

  handleShowAllResults = () =>
    this.setState({ showAllResults: !this.state.showAllResults });

  render() {
    let { results } = this.props;
    const { criteria } = this.props;
    const { showAllResults } = this.state;

    // Sort results using the average for the given criteria
    results = results.sort((a, b) => {
      if (a[criteria.name].average > b[criteria.name].average) return -1;
      if (a[criteria.name].average < b[criteria.name].average) return 1;
      return 0;
    });

    return (
      <div className="row multiple-scale-criteria-resume">
        <div className="col-xs-2 infos">
          <span className="name">{criteria.name}</span>
          <Button
            intent={Intent.PRIMARY}
            minimal={true}
            text="Voir le résultat complet"
            onClick={this.handleShowAllResults}
          />
        </div>

        <div className="col-xs-10 result">
          <div className="title margin-bottom-small">Classement</div>
          <div className="row">
            {results.map((result, index) => {
              const { resource } = result;

              if (!showAllResults && index > 2)
                /** We display only the first 3 results in the criteria resume if showAllResults is false */
                return null;
              return (
                <div key={index} className="animated fadeIn col-xs-4">
                  <div className="ratio16-9 resource-wrapper">
                    <div className="resource-hover">
                      <div className="metadata">
                        <div className="label">Rang</div>
                        <div className="value">{index + 1}</div>
                      </div>
                      <div className="metadata">
                        <div className="label">Moyenne</div>
                        <div className="value">
                          {result[criteria.name].average}/{criteria.max}
                        </div>
                      </div>
                      <div className="metadata">
                        <div className="label">Fichier</div>
                        <div className="value">
                          <Text ellipsize={true}>{resource.file}</Text>
                        </div>
                      </div>
                      <div className="metadata">
                        <div className="label">Nom</div>
                        <div className="value">{resource.name}</div>
                      </div>
                    </div>
                    <div className="resource">
                      {resource.type !== "VIDEO" && (
                        <img
                          className="animated fadeIn img-responsive"
                          alt="Resource (Multiple Scale)"
                          src={resource.downloadURL}
                        />
                      )}
                      {resource.type === "VIDEO" && (
                        <video
                          className="animated fadeIn img-responsive"
                          alt="Resource (Multiple Scale)"
                          src={resource.downloadURL}
                          controls
                          muted
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

class PairComparaisonResults extends React.Component {
  render() {
    const { results, instances } = this.props;
    let maximum = (results.length - 1) * 2 * instances.length

    return (
      <div className="row">
        {_.orderBy(results, ["points"], ["desc"]).map((result, index) => (
          <PairComparaisonResourceResume
            key={index}
            rank={index + 1}
            result={result}
            maximum={maximum}
          />
        ))}
      </div>
    );
  }
}

class PairComparaisonResourceResume extends React.Component {
  state = {
    fullscreen: false
  }

  render() {
    const { result, rank, maximum } = this.props;
    const { resource, points } = result;
    let { fullscreen } = this.state

    return (
      <div className="col-xs-12 col-sm-6 col-lg-4">
        <div className="row pair-comparison-resume">
          <div className="col-xs-12 col-md-7 col-lg-9 no-p-l-r resource">
            <div className="ratio16-9 resource-wrapper">
              <div className="resource">
                {resource.type !== "VIDEO" && (
                  <ReactFullscreen enabled={fullscreen}>
                    <img
                      className="img-responsive cursor-pointer"
                      alt="Resource (Pair comparaison)"
                      src={resource.downloadURL}
                      onClick={() => this.setState({ fullscreen: !fullscreen })}
                    />
                  </ReactFullscreen>
                )}
                {resource.type === "VIDEO" && (
                  <video
                    className="img-responsive"
                    alt="Resource (Pair comparaison)"
                    src={resource.downloadURL}
                    controls
                    muted
                  />
                )}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-5 col-lg-3 infos">
            <div className="metadata">
              <div className="label">Rank</div>
              <div className="value">{rank}</div>
            </div>
            <div className="metadata">
              <div className="label">Points</div>
              <div className="value">{points}</div>
            </div>
            <div className="metadata">
              <div className="label">Rating</div>
              <div className="value">{(points / maximum).toFixed(2)}</div>
            </div>
            <div className="metadata">
              <div className="label">Nom</div>
              <div className="value">{resource.name}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class MultipleChannelResults extends React.Component {
  render() {
    const { session, results } = this.props;
    const { data, metadata } = session;
    const { sequences } = data;
    const { attributes, name } = metadata


    return (
      <div>
        {sequences.map((sequence, index) => {
          const result = results.find(
            result => result.sequence.id === sequence.id
          );

          return (
            <MultipleChannelCriteriaResume
              key={index}
              name={name}
              sequenceIndex={index}
              result={result}
              attributes={attributes}
            />
          );
        })}
      </div>
    );
  }
}

class MultipleChannelCriteriaResume extends React.Component {
  state = {
    fullscreen: false
  }

  render() {
    const { sequenceIndex, result, attributes } = this.props;
    const { sequence } = result;
    const { resources } = sequence;
    let { fullscreen } = this.state

    let totalAttr0 = 0
    let totalAttr1 = 0

    if (attributes && attributes[0]) {
      resources.forEach((channel, i) => {
        if (attributes[0]) {
          totalAttr0 = totalAttr0 + (parseInt(resources[i].attributes[0].quantity) * result[channel.name].average / 100)
        }
        if (attributes[1]) {
          totalAttr1 = totalAttr1 + (parseInt(resources[i].attributes[1].quantity) * result[channel.name].average / 100)
        }
      })
    }

    return (
      <div className="row multiple-channel-criteria-resume" id='personal-results' >
        {/* <div className="col-xs-2 infos">
          <span className="name">Sequence {sequenceIndex + 1}</span>
        </div> */}

        <div className="col-xs-12 result">
          <h2 className='text-center'>SEQUENCE {sequenceIndex + 1}</h2>
          <div className="row">
            <div className="resource-wrapper">
              <div className="resource-hover">
                {resources.map((channel, index) => (
                  <div key={index} className="metadata">
                    <div className="label">{channel.name}</div>
                    <div className="value">{result[channel.name].average}</div>
                  </div>
                ))}
              </div>
              <ReactFullscreen enabled={fullscreen}>
                <div className="resources">
                  {resources.map((channel, index) => (
                    <img
                      key={index}
                      className="img-responsive cursor-pointer"
                      alt="Resource (Multiple Channel)"
                      src={channel.downloadURL}
                      style={{ opacity: result[channel.name].average / 100 }}
                      onClick={() => this.setState({ fullscreen: !fullscreen })}
                    />
                  ))}
                </div>
              </ReactFullscreen>
            </div>
          </div>
          <br /><br />
          <div>
            <div className="attributes-results" >
              {attributes[0] && resources.map((channel, index) => (
                <div key={index}>
                  <h3>{channel.name}: {result[channel.name].average}%</h3>
                  <div>
                    {attributes[0].name}:&nbsp;
                  {parseInt((resources[index].attributes[0].quantity) * result[channel.name].average / 100).toFixed(2)}&nbsp;
                    {attributes[0].unit}
                  </div>
                  {attributes[1] &&
                    <div>
                      {attributes[1].name}:&nbsp;
                  {(parseInt(resources[index].attributes[1].quantity) * result[channel.name].average / 100).toFixed(2)}&nbsp;
                      {attributes[1].unit}

                    </div>
                  }
                </div>
              ))}
            </div>
            <br /><br /><hr /><br />
            {attributes && attributes[0] &&
              <div className='text-center'>
                <h2>SUMMARY</h2>
                <div>{attributes[0].name}: {totalAttr0.toFixed(2)} {attributes[0].unit}</div>
                {attributes[1] &&
                  <div>{attributes[1].name}: {totalAttr1.toFixed(2)} {attributes[1].unit}</div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

class ManualChoiceResults extends React.Component {
  render() {
    const { results } = this.props;
    // let maximum = (results.length - 1) * 2 * instances.length

    return (
      <div>
        {results.map((resultsSequence, i) => {
          return (
            <div className="margin-top-large" key={i}>
              <H3>{resultsSequence.sequenceContext}</H3>
              <div className="row">
                <ManuaChoiceSequence
                  sequence={resultsSequence}
                />
              </div>
            </div>
          )
        })}
        {/* {_.orderBy(results, ["points"], ["desc"]).map((result, index) => (
          <PairComparaisonResourceResume
            key={index}
            rank={index + 1}
            result={result}
            maximum={maximum}
          />
        ))} */}
      </div>
    );
  }
}

const ManuaChoiceSequence = ({ sequence }) => {

  let results = sequence.results
  let maximum = sequence.votersAmount

  return (
    <Fragment>
      {_.orderBy(results, ["points"], ["desc"]).map((result, index) => (
        <PairComparaisonResourceResume
          key={index}
          rank={index + 1}
          result={result}
          maximum={maximum}
        />
      ))}
    </Fragment>

  )
}

export default Result;
